import React, { useState, useEffect } from 'react';
import './Hs.css';
import axios from '../Axiosinstance';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faUser, faSignOutAlt, faContactBook, faComment, faBell, faTimes } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import logoImage from '../images/logopng.png';
import { encryptData, decryptData } from '../Axiosinstance';
import { Modal, Button } from 'react-bootstrap';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge } from '@mui/material';
import { Bell, CheckCircle, User } from "lucide-react";
import { ListGroup } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { faComments } from "@fortawesome/free-solid-svg-icons";


function Headstu(batch, studentId, registrationID) {
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unseenCount, setUnseenCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const studentid = decryptData(localStorage.getItem("studentteacherid"));
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    document.title = "LMS-impluz";
    navigate("/login");
  };

  useEffect(() => {
    const userId = decryptData(localStorage.getItem("userId"));
    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data;
            localStorage.setItem("studentteacherid", encryptData(data.sfid));
            document.title = `impluz - ${data.username}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url);
            fetchNotifications(data.sfid);
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
        });
    }
  }, []);

  const fetchNotifications = (studentId) => {
    axios.get(`student-notifications/unseen/student/${studentId}`)
      .then((res) => {
        console.log("Notifications Data:", res.data); // Logs all unseen notifications
        setNotifications(res.data);
      })
      .catch((err) => console.error("Error fetching notifications:", err));

    axios.get(`student-notifications/unseen-count/student/${studentId}`)
      .then((res) => {
        console.log("Unseen Notifications Count:", res.data); // Logs count of unseen notifications
        setUnseenCount(res.data);
      })
      .catch((err) => console.error("Error fetching unseen notifications:", err));
  };

  const toggleAccount = () => {
    setAccountOpen(!isAccountOpen);
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };



  const markNotificationsAsSeen = async (id) => {
    try {
      const response = await axios.post(`student-notifications/${id}/seen`);
      if (response.status === 200) {
        console.log("Notifications marked as seen successfully");
        // Update state to remove the seen notification
        setNotifications((prevNotifications) =>
          prevNotifications.filter((notification) => notification.id !== id)
        );
        // Update unseen count
        setUnseenCount((prevCount) => (prevCount > 0 ? prevCount - 1 : 0));
      }
    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };



  const markallNotificationsAsSeen = async () => {
    try {
      const response = await axios.post(`student-notifications/mark-all-seen/${studentid}`);
      if (response.status === 200) {
        console.log("Notifications marked as seen successfully");
        setNotifications([]);
        setUnseenCount(0);
      }
    } catch (error) {
      console.error("Error marking notifications as seen:", error);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className={`App ${isNavOpen ? 'opened' : ''}`} style={{ marginBottom: '-5%' }}>
      <nav>
        <div className="logo">
          <img src={logoImage} alt="logo" style={{ width: '120px', height: '60px' }} />
        </div>
        <button className="btn-hamburger" onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`}>

          <li className="nav-item"><Link to="/Dashboard"><FontAwesomeIcon icon={faHome} /> Home</Link></li>
       

          <li className="nav-item"><Link to="/studentchat"><FontAwesomeIcon icon={faContactBook} /> Contact Us</Link></li>

          {/* <li className="nav-item"><Link to={`/student-feedback/${studentid}`}><FontAwesomeIcon icon={faComments} /> Feedbacks</Link></li> */}
          <li className="nav-item notification-icon" onClick={openModal} role="button" tabIndex="0">
            <div className="icon-container"  >
              <Badge badgeContent={unseenCount} color="error">
                <FontAwesomeIcon icon={faBell} className="bell-icon" />
              </Badge>
              Notification
            </div>
            {/* <span className="notification-text">Notifications</span> */}
          </li>

          <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
            <Link to={''} onClick={toggleAccount}>
              {profileUrl ? (
                <img src={profileUrl} alt="Profile" style={{ borderRadius: '50%', width: '50px', height: '50px' }} />
              ) : (
                <FontAwesomeIcon icon={faUser} />
              )} {studentName}
            </Link>
            <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`}>
              <Link className="dropdown-item" to={'/Profilestu'}>Profile</Link>
              <Link onClick={handleLogout} className="dropdown-item" to={'/'}><FontAwesomeIcon icon={faSignOutAlt} /> Log out</Link>
            </div>
          </li>
        </ul>
      </nav>

      <Modal show={showModal} onHide={closeModal} centered fullscreen>
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title className="d-flex align-items-center justify-content-between w-100">
            <span className="fw-bold text-primary">📢 Notifications</span>


          </Modal.Title>

          <FontAwesomeIcon onClick={closeModal} icon={faTimes} />

        </Modal.Header>
        <Modal.Body>
          {notifications.length > 0 ? (
            <div style={{ maxHeight: "300px" }}>
              <ListGroup variant="flush">
                {notifications.map((notification, index) => (
                  <ListGroup.Item
                    key={index}
                    className="d-flex align-items-center justify-content-between p-3"
                    style={{ borderBottom: "1px solid #e0e0e0" }}
                  >
                    <div className="d-flex align-items-center">
                      <Bell size={18} className="text-primary me-2" />
                      <div>
                        <strong>{notification.moduleName}</strong>
                        <p className="mb-0 text-muted" style={{ fontSize: "0.95rem" }}>
                          Assessment Mark Updated By  <strong>{notification.approver}</strong> for <strong>{notification.moduleName}</strong> at <strong>{formatDate(notification.approvedAt)}</strong>.
                        </p>
                      </div>
                    </div>
                    <div className="text-end">
                      <Badge bg="info" className="me-2 px-3 py-2" style={{ fontSize: "0.85rem", borderRadius: "10px" }}>
                        {notification.grade} / 100
                      </Badge>


                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => markNotificationsAsSeen(notification.id)}
                      >
                        <FaCheckCircle size={14} className="me-1" />
                        Mark as Read
                      </Button>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          ) : (
            <div className="text-center py-3">
              <Bell size={32} className="text-muted mb-2" />
              <p className="text-muted">No notifications available</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            // variant="success"
            size="xs"
            className="contained"
            onClick={markallNotificationsAsSeen}
          >
            <FaCheckCircle size={16} className="me-2" />
            Read All
          </Button>
          <Button variant="secondary" onClick={closeModal}>Close</Button>
        </Modal.Footer>
      </Modal>

      <div className="container"></div>
      <div className="container"></div>
    </div>
  );
}

export default Headstu;